import { v4 as uuidv4 } from 'uuid';
import { create } from 'zustand';

export type JobStatus = 'processing' | 'completed' | 'failed';

export interface AISuggestedRiskControl {
  controlId: string | null;
  title: string;
  description: string;
  controlType: string;
  confidenceScore: number;
  isExisting: boolean;
  createdByUser: string;
  createdAtTimestamp: string;
}

export interface AISuggestedRiskControlsResult {
  suggestedControls: AISuggestedRiskControl[];
}

export interface AIWorkflowJobResult<TResult> {
  jobId: string;
  status: JobStatus;
  result: null | TResult;
  error: null | string;
  location: string;
}

export interface AiSuggestedRiskControlsState {
  workflowJobId?: string;
  riskId?: string;
  jobStarted: (riskId: string, jobId: string) => void;
  result?: AIWorkflowJobResult<AISuggestedRiskControlsResult>;
  setResults: (
    results: AIWorkflowJobResult<AISuggestedRiskControlsResult>
  ) => void;
  reset: () => void;
  hasTimedOut: boolean;
  hasErrored: boolean;
  setHasTimedOut: () => void;
  setHasErrored: () => void;
  isJobInProgress: boolean;
}

export const useAISuggestedRiskControlsStore =
  create<AiSuggestedRiskControlsState>((set) => ({
    workflowJobId: undefined,
    riskId: undefined,
    jobStarted: (riskId: string, jobId: string) =>
      set(() => ({
        workflowJobId: jobId,
        isJobInProgress: true,
        riskId: riskId,
      })),
    result: undefined,
    /* eslint-disable-next-line */
    setResults: (result: any) => {
      result.result.suggestedControls = result.result.suggested_controls.map(
        /* eslint-disable-next-line */
        (ctrl: any) => ({
          controlId: ctrl.control_id ?? uuidv4(),
          title: ctrl.title,
          description: ctrl.description,
          controlType: ctrl.control_type,
          confidenceScore: ctrl.confidence_score,
          isExisting: ctrl.is_library_match,
          createdByUser: ctrl.created_by_user ?? 'AI',
          createdAtTimestamp:
            ctrl.created_at_timestamp ?? new Date().toISOString(),
        })
      );

      set(() => ({ result, isJobInProgress: false }));
    },
    reset: () =>
      set({
        workflowJobId: undefined,
        result: undefined,
        hasTimedOut: false,
        hasErrored: false,
        isJobInProgress: false,
      }),
    hasTimedOut: false,
    hasErrored: false,
    setHasTimedOut: () => {
      set(() => ({
        hasTimedOut: true,
        isJobInProgress: false,
      }));
    },
    setHasErrored: () => {
      set(() => ({
        hasErrored: true,
        isJobInProgress: false,
      }));
    },
    isJobInProgress: false,
  }));
